export default {"src":"/_next/static/media/accidentOutline100_40.6ffac899.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};